<template>
    <div v-if="mixer">
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Modificar Mixer</template>
            <template #center>
                <div class="nj-card">
                    <div class="nj-cols form c2">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_nombre" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Placa</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_placa" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Capacidad</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_capacidad" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Estado</div>
                            <select class="nj-select" v-model="mixer.est_id">
                                <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="modificar()"><i class=" mdi-content-save"></i>Modificar</button>
            </template>
        </Box>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import { Box } from "../components"
import { AppService, ResponseStatus, MixerService } from "../../rest"
import Arrays from "../../util/arrays"

export default {
    name: "ModificarMixer",
    components: {
        Box
    },
    props: {
        mix_id: {
            type: Number
        }
    },
    data() {
        return {
            mixer: null,
        }
    },
    methods: {
        modificar() {
            MixerService.modificar({
                mixer: this.mixer
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.cerrar(true)
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        cerrar(condition) {
            this.$emit("close", { componente: 'modificar', abrir: false, buscar: condition })
        }
    },
    mounted() {
        // obteniendo los estados
        AppService.getData(["estados"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["activo", "inactivo"])
                    // buscando al mixer
                    MixerService.obtener({
                        mixer: {
                            mix_id: this.mix_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.mixer = response.data
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )

    }
}
</script>

<style scoped></style>